import { render, staticRenderFns } from "./SidenavList.vue?vue&type=template&id=865850f0&"
import script from "./SidenavList.vue?vue&type=script&lang=js&"
export * from "./SidenavList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports